export class PaymentModel {
  public MortgageAccountNumber: string;
  public SubAccountNumber: number;
  public MortgageHolderLastName: string;
  public MortgageHolderDateOfBirth: Date;
  public PropertyPostCode: string;
  public PayeeName: string;
  public PostCode: string;
  public PhoneNumber: string;
  public Amount: number | string;
  public Source: string;
  public PaymentType: string;
  public PaymentOperationID: number;
  public CaptchaToken: string;
  public SourcesOfFunds: Array<string>;
  public SOFOtherDetails: string;
  public SOFGiftDetails: string;
  public TypeOfReduction: string;

  constructor() {
    this.MortgageHolderDateOfBirth = new Date('01/01/1990 0:00:00 AM UTC');
    this.SubAccountNumber = 0;
  }
}
